import { Card, Text } from '@ui/atoms';
import AssesmentTitleCard from './AssesmentTitleCard';
import texts from './en.json';
const PostSanctionMonitoring = () => {
    return (
        <div className="mt-0 mb-16 md:mb-20 xl:mb-24">
            <AssesmentTitleCard
                title={texts.PostSanctionMonitoringStep}
                description={texts.PostSanctionMonitoring}
            />
            <div className="flex flex-col mt-10 mx-6 md:mx-10">
                <Card className="flex items-center justify-center w-full p-4 md:p-8 bg-basicWhite shadow-xs border border-secondary-50">
                    <Text
                        content="We periodically engage with the counterparty to assess their financial health, monitor covenants, and identify any early stress signals to take pre-emptive corrective actions."
                        className="p5-regular md:p4-regular text-basicBlack"
                    />
                </Card>
            </div>
        </div>
    );
};

export default PostSanctionMonitoring;
